import { useState } from "react";
import { FormConig , PageData } from "../interfaces/index";
import { SendPrescriptionPage, SendPrescriptionInputsFields } from '../constants/index'
import {Header} from "../components/header/header";
import { Form} from "../components";

export const SendPrescriptionForm = () => {
  const [inputAttributes, setFormConig] = useState<FormConig[]>(
    SendPrescriptionInputsFields
  );
  const [pageData, setPageData] = useState<PageData>(SendPrescriptionPage);

  return (
    <div>
      <Header img={pageData.image} headerLabel={pageData.title} />
      <Form formHeaderText={pageData.header} inputAttributes={inputAttributes} />
    </div>
  );
}

